<template>
  <div>
    <div class="content-header d-flex d-lg-none">
      <h6>{{ _T_DB(item, 'name') }}</h6>
      <a href="javascript:void(0)" class="close_filter" @click="close()">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
            fill="#3D3F43"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
            fill="#3D3F43"
          />
        </svg>
      </a>
    </div>
    <div class="customized-img" v-if="item">
      <div
        v-if="
          sliderImages.normal_size.length &&
            sliderImages.normal_size[0] &&
            sliderImages.normal_size[0].url.length
        "
      >
        <a
          href="javascript:void(0)"
          class="close-icon"
          @click.prevent="close()"
        >
          <svg fill="white">
            <use xlink:href="#close-icon-white" />
          </svg>
        </a>
        <swiper
          class="swiper gallery-top"
          :options="swiperOptionTop"
          ref="swiperTop"
        >
          <swiper-slide
            :key="k"
            v-for="(img, k) of sliderImages.normal_size"
            :class="'slide-' + k"
          >
            <inner-image-zoom
              :src="img.url"
              :zoomSrc="sliderImages.large_size[k].url"
              :alt="item.name"
              fullscreenOnMobile
            />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <swiper
          class="swiper gallery-thumbs"
          :options="swiperOptionThumbs"
          ref="swiperThumbs"
        >
          <swiper-slide
            :key="k"
            v-for="(img, k) of sliderImages.thumbs"
            :class="'slide-' + k"
          >
            <img :src="img.url" />
          </swiper-slide>
        </swiper>
      </div>
      <div
        v-else
        :style="{
          'background-color': item.item_color ? item.item_color : '#f02',
        }"
        class="bg-size"
      >
        <a
          href="javascript:void(0)"
          class="close-icon"
          @click.prevent="close()"
        >
          <svg fill="white">
            <use xlink:href="#close-icon-white" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import InnerImageZoom from 'vue-inner-image-zoom'
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css'
import 'swiper/css/swiper.css'

// function reverseArray(arr) {
//   var newArray = []
//   for (var i = arr.length - 1; i >= 0; i--) {
//     newArray.push(arr[i])
//   }
//   return newArray
// }

// import ProgressBar from '@/components/Elements/Loader.vue'
export default {
  name: 'ItemDetailsTop',
  data() {
    return {
      currentImagePath: '',
      isLoading: true,
      multiImg: [],
      sliderImages: {
        thumbs: [],
        normal_size: [],
        large_size: [],
      },
      swiperOptionTop: {
        updateOnWindowResize: true,
        allowTouchMove: true,
        slidesPerView: 1,
        allowSlidePrev: true,
        allowSlideNext: true,
        spaceBetween: 10,
        preloadImages: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: false,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    }
  },
  components: {
    // ProgressBar,
    'inner-image-zoom': InnerImageZoom,
  },
  mounted() {},
  watch: {
    item(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.currentImagePath = ''
          this.sliderImages = {
            thumbs: [],
            normal_size: [],
            large_size: [],
          }
          this.multiImg = []
          this.getImage()
        })
      }
    },
  },
  computed: {
    ...mapGetters([
      '_T_DB',
      '_T',
      'discounted_menu_price',
      'currentBrand',
    ]),
    ...mapState({
      item: state => state.cart_store.selectedItem,
    }),
  },
  methods: {
    close() {
      this.$store.commit('SET_ITEM_DETAIL_POPUP', false)
      document.body.classList.remove('body-overlay')
    },
    getImage() {
      if (this.item) {
        // let url = this.item.image.split('menu/')
        let that = this
        this.sliderImages = {
          thumbs: [],
          normal_size: [],
          large_size: [],
        }
        this.multiImg = this.item.images || []
        if (
          this.currentBrand &&
          this.currentBrand.item_layout &&
          (this.currentBrand.item_layout == 'default' ||
            this.currentBrand.item_layout ==
              'square_layout_long square_layout_mid')
        ) {
          if (this.item.images.length == 0) {
            this.multiImg.push({
              _id: { $oid: this.item._id },
              image: this.item.image,
            })
          }
        }
        this.multiImg.map(i => {
          let imgUrl = i.image.split('menu/')
          let imgPathThumb = i.image
          let imgPathNormal = imgUrl[1]
            ? imgUrl[0] + 'menu/large/' + imgUrl[1]
            : i.image
          let imgPathOriginal = imgUrl[1]
            ? imgUrl[0] + 'menu/original/' + imgUrl[1]
            : i.image
          that.sliderImages.thumbs.push({
            id: i._id.$oid,
            url: imgPathThumb,
          })
          that.sliderImages.normal_size.push({
            id: i._id.$oid,
            url: imgPathNormal,
          })
          that.sliderImages.large_size.push({
            id: i._id.$oid,
            url: imgPathOriginal,
          })
        })
        setTimeout(this.updateRefs, 1000)
      }
    },
    updateRefs() {
      if (this.$refs.swiperTop && this.$refs.swiperThumbs) {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      }
    },
  },
  beforeDestroy() {
    this.currentImagePath = ''
    this.sliderImages = {
      thumbs: [],
      normal_size: [],
      large_size: [],
    }
    this.multiImg = []
  },
}
</script>

<style lang="scss">
.zoomedPane {
  border-radius: 10%;
  float: right;
  top: 5% !important;
  left: -40% !important;
  position: absolute !important;
  z-index: 99;
  cursor: pointer;
}
.close-icon {
  position: absolute;
  top: $px10;
  left: $px5;
  z-index: 1111;
  background-color: $color-primary !important;
  border: $px4 solid $color-primary-1, 30%;
  border-radius: 50%;
  @media (max-width: 575px) {
    display: none;
  }
  svg {
    width: $px32;
    height: $px32;
  }
}
</style>
<style lang="scss" scoped>
.swiper {
  .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  &.gallery-top {
    height: 80%;
    width: 100%;
  }
  &.gallery-thumbs {
    height: 10%;
    box-sizing: border-box;
    padding: 5px 0;
  }
  &.gallery-thumbs .swiper-slide {
    width: 10%;
    height: 100%;
    opacity: 0.4;
  }
  &.gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }
  .swiper-button-prev {
    color: $color-primary;
  }
  .swiper-button-next {
    color: $color-primary;
  }
}

.swiper-container {
  z-index: 0 !important;
}
.customized-img {
  position: relative;
  .bg-size {
    background-size: contain !important;
    background-position: center center;
    background-repeat: no-repeat;
    &:before {
      padding-top: 60%;
    }
  }
  img {
    width: 100%;
    height: auto;
  }
  .total-box {
    background: rgba(var(--color-font-color-source), 0.5);
    padding: $px10 $px12;
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: right;
    h6 {
      font-weight: normal;
      font-size: $px14;
      line-height: $px22;
      letter-spacing: 0.5px;
      color: $white;
      text-transform: capitalize;
      margin-bottom: $px5;
    }
    h5 {
      font-weight: normal;
      font-size: $px18;
      line-height: $px22;
      color: $color-primary;
      text-transform: uppercase;
      margin-bottom: 0;
    }
    &.light-version {
      background: rgba(var(--color-white-source), 0.5);
      h6 {
        color: $black;
      }
    }
  }
}
</style>
